/* eslint-disable no-shadow */

import { AgentsFilterSelection } from '@/views/agents/components/agents-table/types/agents-table.types';

export enum MatomoCategories {
  'Agents' = 'Agents Page',
  'ExternalLink' = 'External Link',
  'Settings' = 'Settings Page',
  'User' = 'Users Management Page',
  'Workloads' = 'Build list - manage columns',
  'InstallAgent' = 'Install Agent Page',
  'GettingStarted' = 'Getting Started Page',
}

export enum MatomoAgentsActions {
  'ColumnSelectionReset' = 'Column Selection Reset',
  'ColumnSelection' = 'Column Selection',
  'ScaleToCloud' = 'Scale to Cloud',
}

export enum MatomoExternalLinkActions {
  'Click' = 'Click',
}

export enum MatomoSettingsActions {
  'ScaleToCloud' = 'Scale to Cloud',
  'Save' = 'Save',
}

export enum MatomoUserActions {
  'Add' = 'Add',
}

const menuActions = [
  'Select/Unselect Enabled as Helper',
  `Select/Unselect Allow to 'enable/disable as helper'`,
  'Select/Unselect Allocate Build Cache',
  'Select submit License configurations',
  'Select submit cache size',
  'Select submit Build Cache Folder Location',
  'Select unsubscribe agent',
  'Select submit Agent Description',
  'Select assignment priority',
  'Select Build priority',
  'Select build group',
  'Add Build Group',
  'Select Log level',
  'Select clean helper cache',
  'Select submit advanced configurations',
] as const;

export const MatomoEvents = {
  'Dashboard Filter': ['Apply Initiator type', 'Apply Workload type', 'Apply build group', 'Apply Date'],
  'Workloads Sort': ['Click'],
  'Workloads Filter': ['Apply  Status', 'Apply duration', 'Apply build Group'],
  'Workloads Search': ['Apply'],
  'Smart Select': [
    AgentsFilterSelection.All,
    AgentsFilterSelection.Online,
    AgentsFilterSelection.Offline,
    AgentsFilterSelection.Cloud,
    AgentsFilterSelection.IncompatibleVersion,
    AgentsFilterSelection.DuplicateLicense,
    'All On Page',
    'Clear All',
  ],
  'Build list - manage columns': ['Column Selection Reset', 'Column Selection'],
  'Build list - open build': ['Click'],
  'Install Agent Page': ['Click'],
  'Getting Started Page': ['Click'],
  'Build page': ['Click'],
  'Quick Filter': ['Show All', 'Online', 'In Process', 'Selected Agents', 'Incompatible Version', 'Unlicensed Agents'],
  'Menu Open': ['Right click/ 3 dots'],
  'Agent Menu Single Action': [...menuActions],
  'Agent Menu Bulk Action': [...menuActions],
  'Side Bar': ['Agents', 'Users', 'Settings'],
  'License Page': ['Deactivate', 'Copy License', 'Update License'],
  'Agents Filter': [
    'Open/ Close Filter',
    'Clear All',
    'Select/ Unselect status type',
    'Select/ Unselect operating system type',
    'Click on Range Selector - Available CPU',
    'Select / Unselect Agent cores',
    'Select / Unselect License Type',
    'Click on Range for Helper Cache Size',
    'Select / Unselect Helper Enabled',
    'Select / Unselect Build Groups',
    'Select / Unselect Agent Helper Permissions',
    'Select / Unselect Log Level',
  ],
  'Agents Page': ['Column Selection Reset', 'Column Selection', 'Scale to Cloud', 'Hide/Show Status Bar', 'Submit Build group', 'Select Filters', 'Select search', 'Select/Unselect Agent'],
  'External Link': ['Click'],
  'Settings Page': ['Scale to Cloud', 'Save', 'Change Input'],
  'Users Management Page': ['Add'],
  'User Api': ['Add Key', 'Delete Key'],
  'API Access': ['Add key', 'Copy Coordinator id', 'Delete key', 'Change Description'],
} as const;
